import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useLandingPage = (landingPageId: string | number | undefined) => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.LANDING_PAGE_BY_ID(landingPageId!),
    queryFn: () => shopApi.fetchLandingPageById(Number(landingPageId)),
    enabled: !!landingPageId,
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.LANDING_PAGE_BY_ID(landingPageId!),
    });
    // Also invalidate the list cache
    queryClient.invalidateQueries({
      predicate: (query) => query.queryKey[0] === "landingPages",
    });
  };

  return {
    isLoading,
    isFetching,
    landingPage: data?.data,
    invalidate,
  };
};
